import React, { useEffect, useState } from 'react'
import { EditPage } from '@equipedigitalfloripa/ed-cms/components'
// import { EditPage } from '../components/EditPage'
import * as arquivoApi from '../api/arquivos'
import { fetchItems } from '../api/categoriaArquivos'
import { useSelector } from 'react-redux'

const EditArquivo = ({ edit }) => {
  const translations = useSelector(state => state.translations.translations)
  const arquivosTranslations = translations['system-arquivos']

  const [categoriaArquivos, setCategorias] = useState([])

  useEffect(() => {
    fetchItems().then(res => {
      let categoriaArquivosOptions = []
      res.data.forEach(categoria => {
        categoriaArquivosOptions.push({ value: categoria._id, label: categoria.title })
      })
      setCategorias(categoriaArquivosOptions)
    })
  }, [])

  const selectedData = [
    {
      name: '_id',
      type: 'hidden',
      title: 'Id'
    },
    {
      name: 'title',
      type: 'text',
      title: "Nome Arquivo",
      validation: {
        required: true
      },
      options: {
        maxLength: '150'
      },
    },
    {
      name: 'description',
      type: 'text',
      title: "descrição",
      options: {
        optional: true
      }
    },
    {
      name: 'category',
      type: 'select',
      title: "Categoria",
      selectOptions: categoriaArquivos,
      options: {
        populated: true
      }
    },
    {
      name: 'file',
      type: 'file',
      title: "Arquivo",
      options: {
        maxFiles: 1
      },
      validation: {
        required: true
      },
      
    },
    
  ]
  return (
    <EditPage
      title={edit ? "Editar Arquivo" : "Adicionar Arquivo"}
      subtitle={edit ? "alterar informações" : "Informações necessárias"}
      selectedData={selectedData} 
      addFunction={arquivoApi.addItem}
      fetchFunction={arquivoApi.fetchItem}
      editFunction={arquivoApi.editItem}
      uploadFunction={arquivoApi.uploadArquivo}
      edit={edit}
      url='arquivos'
    />
  )
}

export default EditArquivo
